import React from "react";
import { useSelector } from "react-redux";
import { selectWebp } from "../features/ui/uiSlice";

const Logo = () => {
    const isWebp = useSelector(selectWebp);
    return <img src={isWebp ? '../assets/fl-logo.webp' :'../assets/fl-logo.png'} alt='logo' width='91' height='91'/>
};

export default Logo;